import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

// Components
import Spinner from "../Components/Spinner";
import VehicleFiltersComponent from "../Components/Filters/VehicleFiltersComponent";
import { ToastComponent } from "../Components/ToastComponent";

// Services
import { downloadService } from "../../Services/download.service";
import GridReport from "../Components/Grid/GridReport";

export default function ReportPage({
  pageTitle,
  reportServiceFunction,
  pageGrid,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch(); // eslint-disable-next-line
  dispatch({ type: "title", value: pageTitle });

  const [toastParams, setToastParams] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [gridInfo, setGridInfo] = useState(null);

  const handleClearGrid = () => {
    setGridInfo(null);
  };

  const handleGenerateReport = async (
    groupId,
    vehicleId,
    initDateTime,
    endDateTime,
    durationTime,
    fileType,
    speed,
    download,
    driverId,
    eventType,
    userId
  ) => {
    
    if (validatePageFilters(pageTitle, vehicleId, userId)) {

      
      if (!download) setGridInfo(null);
      setToastParams(JSON.stringify({ show: false }));
      setIsLoading(true);

      try {
        const payload = {
          groupId,
          vehicleId,
          dateTimeScheduleStart: initDateTime,
          dateTimeScheduleEnd: endDateTime,
          durationTime,
          fileType,
          speed,
          driverId: pageGrid == "gridJourneyWork" ? driverId : 0,
          eventType,
          userId,
          pageSize: 9999,
          pageNumber: 1
        };

        const response = await reportServiceFunction(payload, download);

        if (!download) {
          setGridInfo(response);
        } else if (response && fileType) {
          downloadService.downloadBase64File(response, fileType, pageTitle);
        } else {
          setToastParams(
            JSON.stringify({
              show: true,
              title: t("REPORTS.REPORT_REQUEST"),
              body: t("REPORTS.NO_DATA_IN_RESPONSE"),
              color: "warning",
            })
          );
        }
      } catch (error) {
        setToastParams(
          JSON.stringify({
            show: true,
            title: t("REPORTS.FILTER_VALIDATION"),
            body: `${t("REPORTS.ERROR_FETCHING_REPORT")} ${pageTitle}`,
            color: "warning",
          })
        );
        console.error(`${t("REPORTS.ERROR_FETCHING_REPORT")} ${pageTitle}:`, error);
      } finally {
        setIsLoading(false);
      }
    } else {
      setToastParams(
        JSON.stringify({
          show: true,
          title: t("REPORTS.FILTER_VALIDATION"),
          body: t("REPORTS.SELECT_VEHICLE"),
          color: "warning",
        })
      );
    }
  };

  function validatePageFilters(pageTitle, vehicleId, userId) {
    switch (pageTitle) {
      // Não funciona com vehicleId = 0
      case "Distância Percorrida":
      case "Controle de Uso":
        return vehicleId && vehicleId != 0;
      // Funciona com vehicleId = 0
      case "Posicionamento":
      case "Deslocamento":
      case "Controle de Velocidade":
      case "Visitas por veículos":
      case "Veículos em visitas":
      case "Protocolos de Atendimento":
        return vehicleId != null;
      // Só precisa do userId preenchido
      case "Logs":
        return userId != null;
      default:
        return false;
    }
  }

  return (
    <div className="container-xxl flex-grow-1 container-p-y">
      <ToastComponent
        params={toastParams}
        closeToast={() => setToastParams(JSON.stringify({ show: false }))}
      />
      <VehicleFiltersComponent
        handleClearGrid={handleClearGrid}
        handleCallback={handleGenerateReport}
        page={pageGrid}
      />
      {gridInfo && <GridReport gridData={gridInfo} pageGrid={pageGrid} />}
      {isLoading && <Spinner />}
    </div>
  );
}